import React from 'react'
import { Stack } from '@mui/material'
import { makeStyles } from 'tss-react/mui'

import { Typography } from '@e3dc-react/shell/Elements/Typography'

const useStyles = makeStyles()(theme => ({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: theme.spacing(2),
    padding: theme.spacing(2),
    width: '100%',

    borderColor: theme.palette.shades.shade03,
    backgroundColor: theme.palette.shades.shade04,
    borderRadius: theme.spacing(2),
  },
}))

interface Props {
  message: string
  containerClassName?: string
  leftIcon?: React.ReactElement
  rightIcon?: React.ReactElement
}

const ApiAccessInformationTile: React.FC<Props> = ({ message, containerClassName, leftIcon, rightIcon }) => {
  const { classes, cx } = useStyles()
  return (
    <Stack className={cx(classes.container, containerClassName)}>
      {leftIcon}
      <Typography variant="caption">{message}</Typography>
      {rightIcon}
    </Stack>
  )
}

export default ApiAccessInformationTile
